import { useHistory } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';

import ParsedCell from './ParsedCell.jsx';

const highlightPulse = keyframes`
  0% {
    background-color: rgba(229, 242, 255, 0.8);
  }
  25% {
    background-color: rgba(229, 242, 255, 0.3);
  }
  50% {
    background-color: rgba(229, 242, 255, 0.8);
  }
  75% {
    background-color: rgba(229, 242, 255, 0.3);
  }
  100% {
    background-color: transparent;
  }
`;

const BodyTr = styled.tr`
  height: 43px;
  position: relative;
  ${props =>
    props.clickable &&
    css`
      cursor: pointer;
      &:hover {
        background-color: rgba(229, 242, 255, 0.5) !important;
      }
      transition: background-color 0.1s ease-out;
    `};

  &.highlighted {
    animation: ${highlightPulse} 3s ease-out forwards;
  }
`;

const Body = ({ body }) => {
  const history = useHistory();

  const handleCellClick = (cell, dataHref) => {
    if (!cell.shouldLinkTo) return;
    history.push(dataHref);
  };

  return (
    <tbody>
      {body.map(row => (
        <BodyTr
          key={row.info.uuid}
          className={row.info.className}
          data-tile-id={row.info.dataTileId}
          data-href={row.info.dataHref}
          hasBorder={row.info.hasBorder}
          clickable={row.info.clickable}
        >
          {row.cells.map((cell, j) => (
            <ParsedCell
              key={j}
              cell={cell}
              hasDivider={row.info.hasDivider}
              onClick={() => handleCellClick(cell, row.info.dataHref)}
            />
          ))}
        </BodyTr>
      ))}
    </tbody>
  );
};

export default Body;
